import React from "react";

function ReportResultsTable({
  title = "Report Results",
  subtitle,
  selectedColumns = [],
  rows = [],
  emptyMessage = "Run the report to view results.",
  toolbar = null,
  formatFieldName,
  getColumnStyle
}) {
  return (
    <div className="sales-table-card">
      <div className="sales-table-header">
        <div>
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
      </div>

      {toolbar}

      <div className="sales-table-wrap">
        <table className="sales-table">
          <thead>
            <tr>
              {selectedColumns.map((column) => (
                <th key={column} style={getColumnStyle ? getColumnStyle(column) : undefined}>
                  {formatFieldName(column)}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td
                  colSpan={selectedColumns.length || 1}
                  className="sales-empty-cell"
                >
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              rows.map((row, index) => (
                <tr key={index}>
                  {selectedColumns.map((column) => (
                    <td key={column} style={getColumnStyle ? getColumnStyle(column) : undefined}>
                      {row[column] ?? "-"}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ReportResultsTable;